import "../../athlete.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ReactComponent as EditIcon } from "../../../../assets/elevva-pro-icons/edit-icon.svg";
import { useState } from "react";
import ModalInfo from "../modal-info";
import InjuriesModal from "../injuries-modal";

const Step3 = ({ edit, userDetail, setFormData }) => {
  const lesiones = userDetail?.injuries_and_registers?.injuries || {};
  const [modal, setModal] = useState(null);
  const [textInjuries, setTextInjuries] = useState("");

  function handleSave(injurie, zone, newText) {
    setFormData((prev) => ({
      ...prev,
      injuries_and_registers: {
        ...prev.injuries_and_registers,
        injuries: {
          ...prev.injuries_and_registers.injuries,
          [zone]: prev.injuries_and_registers.injuries[zone].map((item) =>
            item.id === injurie.id ? { ...item, summary: newText } : item
          ),
        },
      },
    }));
    setModal(null);
  }

  function handleModal(injurie, key) {
    setModal(
      <InjuriesModal
        injurie={injurie}
        onSave={(newText) => handleSave(injurie, key, newText)}
        onCancel={() => setModal(null)}
      />
    );
  }

  return (
    <div
      className="d-flex flex-column col-2 px-2 h-100"
      style={{ width: "20%" }}
    >
      {modal}
      <div className="d-flex justify-content-start h-auto">
        <span className="label-step">
          <strong>3. Lesiones y dolores registrados</strong>
        </span>
      </div>

      <div className="pt-2 d-flex flex-column gap-2 h-100 overflow-hidden">
        {/* Bloque 1: Lesiones */}
        <div
          className="step3-card input_info_athlete p-2 d-flex "
          style={{ height: "60%", overflow: "hidden" }}
        >
          <PerfectScrollbar className="flex-grow-1 px-2 overflow-auto">
            <ul className="ps-3 mb-0">
              {Object.entries(lesiones).map(([key, item]) => (
                <li key={key} className="py-1">
                  <strong>{key}:</strong>
                  <br />
                  {item.map((i) => (
                    <div className="d-flex gap-1 align-items-center" key={i.id}>
                      <span>✅ {i.summary}</span>
                      {edit && (
                        <div className="d-flex align-items-center">
                          <EditIcon
                            onClick={() => handleModal(i, key)}
                            className="cursor-pointer"
                            width={"1rem"}
                            height={"1rem"}
                          />
                        </div>
                      )}
                    </div>
                  ))}{" "}
                </li>
              ))}
            </ul>
          </PerfectScrollbar>
        </div>

        {/* Bloque 2: Exámenes */}
        <div
          className="step3-card input_info_athlete p-2 d-flex flex-column"
          style={{ height: "auto", overflow: "hidden" }}
        >
          <span className="label-step mb-2">Exámenes Complementarios</span>
          <div className="flex-grow-1 px-2 step3-card-text ">
            <textarea
              className="input_info_athlete_input"
              defaultValue={
                userDetail?.injuries_and_registers?.complementary_exams || ""
              }
              readOnly={!edit}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  injuries_and_registers: {
                    ...prev.injuries_and_registers,
                    ["complementary_exams"]: e.target.value,
                  },
                }));
              }}
            />
            {/* <ul className="ps-3 mb-0">
              {lesiones.map((item, index) => (
                <li key={index} className="py-1">
                  {item.value}
                </li>
              ))}
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3;
